// src/Services/Wishlist.js
import { fetchProductBySlug } from './ProductServices';

export const fetchWishlistProducts = async (slugs) => {
  try {
    const productPromises = slugs.map(slug => fetchProductBySlug(slug));
    const products = await Promise.all(productPromises);
    
    // Since fetchProductBySlug returns an array with product at index 0
    return products
      .filter(response => response && response.length > 0)
      .map(response => response[0]);
  } catch (error) {
    console.error('Error fetching wishlist products:', error);
    throw error;
  }
};